import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Cabeçalho de página do painel (redesign 2026): título em Bricolage,
 * descrição, badges ao lado do título e ações à direita. Só layout —
 * não sabe de rota nem de dado.
 */
export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Botões à direita (ex.: "Novo post"). */
  actions?: ReactNode;
  /** Elemento antes do título (ex.: botão voltar). */
  leading?: ReactNode;
  /** Badges/pílulas na mesma linha do título (ex.: estágio do lead). */
  meta?: ReactNode;
  /** `lg` = página de módulo (27px); `md` = página de detalhe (25px). */
  size?: "lg" | "md";
  className?: string;
}

export function PageHeader({
  title,
  description,
  actions,
  leading,
  meta,
  size = "lg",
  className,
}: PageHeaderProps) {
  return (
    <header className={cn("flex flex-wrap items-start justify-between gap-4", className)}>
      <div className="flex min-w-0 items-center gap-3">
        {leading}
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2.5">
            <h1
              className={cn(
                "font-display font-bold tracking-[-0.03em]",
                size === "lg" ? "text-[27px]" : "text-[25px] leading-none",
              )}
            >
              {title}
            </h1>
            {meta}
          </div>
          {description && (
            <p
              className={cn(
                "text-[13.5px] text-muted-foreground",
                size === "lg" ? "mt-1.5" : "mt-[5px]",
              )}
            >
              {description}
            </p>
          )}
        </div>
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}
